import { ACTIONS } from '../Constants';

const initialState = {
    modalType: null,
    modalProps: {}
};

const modal = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.SHOW_MODAL: {
            return {
                modalType: action.modalType,
                modalProps: action.modalProps
            };
        }
        case ACTIONS.HIDE_MODAL: {
            return initialState;
        }
        default:
            return state;
    }
};

export default modal;
